export const START_SUBMIT_SUPPORT_FORM_FLOW = 'START_SUBMIT_SUPPORT_FORM_FLOW';

export const SUPPORT_FORM_SUBMIT_REQUEST_SENT = 'SUPPORT_FORM_SUBMIT_REQUEST_SENT';
export const SUPPORT_FORM_SUBMIT_REQUEST_SUCCEEDED = 'SUPPORT_FORM_SUBMIT_REQUEST_SUCCEEDED';
export const SUPPORT_FORM_SUBMIT_REQUEST_FAILED = 'SUPPORT_FORM_SUBMIT_REQUEST_FAILED';
export const SUPPORT_FORM_SUBMIT_REQUEST = 'SUPPORT_FORM_SUBMIT_REQUEST';

export const SET_SUPPORT_MODAL_OPEN_STATUS = 'SET_SUPPORT_MODAL_OPEN_STATUS';

